module.exports = __webpack_public_path__ + "media/images/insel-spital-logo-fb231ad9ec2842e2c149a2db08b837cc.png";